<template>
  <v-container fill-height>
    <v-layout align-center justify-center row>
      <v-progress-circular :size="200" indeterminate color="primary">
        <v-img :src="logo" width="150" />
      </v-progress-circular>
    </v-layout>
  </v-container>
</template>

<script>
import logo from "../assets/logo-main.png";
export default {
  data() {
    return {
      logo,
    };
  },
};
</script>

<style>
</style>
